import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { userAppContext } from '../../context/Context';
import { USER_ROLES_AWS_MAP } from '../../constants/userRoles';
import QueriesLimitTable from '../API/QueriesLimitTable';
import UpgradePlan from '../User/UpgradePlan';
import { useAcademicExpiration } from '../../hooks/useAcademicExpiration';
import AcademicExpirationInlineTag from '../Academic/AcademicExpirationInlineTag';
import AcademicExpirationModal from '../Academic/AcademicExpirationModal';

interface ProfileDataProps {
  profileDataClass?: string;
}

interface CognitoUser {
  email: string;
  'custom:company'?: string;
  identities?: any[];
  [key: string]: any;
}

const ProfileData: React.FC<ProfileDataProps> = ({ profileDataClass }) => {
  const { user, groups } = userAppContext();
  const [message] = useState('');

  const navigate = useNavigate();

  // Academic expiration logic
  const {
    expirationStatus,
    showWarningModal,
    warningType,
    loading,
    isAcademic,
    shouldShowExpirationTag,
    tagInfo,
    handleRenewal,
    handleCancellation,
    dismissWarning,
    openModal,
    hasAppliedForRenewal,
    hasCancelledAccount,
    wasRenewalDenied,
    wasRenewalApproved,
    currentAcademicPlan,
  } = useAcademicExpiration(user, true);

  const handleReset = (evt: React.MouseEvent<HTMLAnchorElement>) => {
    evt.preventDefault();
    navigate('/Reset');
  };

  const userRole = USER_ROLES_AWS_MAP.get(groups?.[0]);
  const isExternal = user?.identities ? true : false; // if user is from an external identity provider, then it has identities field

  return (
    <>
      <div className={`${profileDataClass}`} id="profilelData">
        <h2>Profile Data</h2>
        <div className="wrap-input100" />

        {user?.['custom:company'] ? (
          <>
            {' '}
            <p className="input100">Company: </p>
            <span className="label-input100">{user?.['custom:company']}</span>
            <div className="wrap-input100" />
          </>
        ) : null}

        <p className="input100">Email: </p>
        <span className="label-input100">{user?.email}</span>
        <div className="wrap-input100" />

        <p className="input100">Plan: </p>
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <h6 className="label-input100">{userRole}</h6>
            {/* Academic Expiration Tag */}
            {isAcademic && shouldShowExpirationTag && (
              <AcademicExpirationInlineTag tagInfo={tagInfo} onClick={openModal} />
            )}
          </div>
          <UpgradePlan />
        </div>
        <div className="wrap-input100" />
        <div className="pt-4">
          <QueriesLimitTable />
        </div>
        <div className="" />
        <p style={{ color: 'red' }}>{message}</p>
        {!isExternal && (
          <a className="input100 resetApiKeyandPass" href="#" onClick={handleReset}>
            Change Password
          </a>
        )}
      </div>

      {/* Academic Expiration Modal */}
      {isAcademic && (
        <AcademicExpirationModal
          open={showWarningModal}
          onClose={dismissWarning}
          warningType={warningType}
          expirationStatus={expirationStatus}
          onRenewal={handleRenewal}
          onCancellation={handleCancellation}
          loading={loading}
          hasAppliedForRenewal={hasAppliedForRenewal}
          hasCancelledAccount={hasCancelledAccount}
          wasRenewalDenied={wasRenewalDenied}
          wasRenewalApproved={wasRenewalApproved}
          currentAcademicPlan={currentAcademicPlan}
        />
      )}
    </>
  );
};

export default ProfileData;
